import * as React from "react";
import {
  container,
  subTitle,
  historyTitle,
  description,
  imageHistory,
  imageContainer,
  historyCarouselFull,
  line,
  circleContainer,
  circle,
  timeContent,
  timeContainer,
  controls,
  historyCarouselMobile,
} from "./History.module.scss";
import Carousel from "react-bootstrap/Carousel";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Col } from "react-bootstrap";
import { IHistoryProps } from "./HistoryProps";
import { slugify } from "transliteration";

export const StyledContainer: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  return <Container className={container}>{props.children}</Container>;
};

export const ImageContainer: React.FC<{ image: any; title: string }> = (
  props
) => {
  return (
    <Col className={imageContainer}>
      <GatsbyImage
        image={props.image.gatsbyImage}
        alt={props.title}
        className={imageHistory}
      />
    </Col>
  );
};

export const StyledSubTitle: React.FC<any> = (props) => {
  return (
    <div id={props.id} className={subTitle}>
      {props.children}
    </div>
  );
};

export const HistoryTitle: React.FC<any> = (props) => {
  return (
    <h2 id={props.id} className={historyTitle}>
      {props.children}
    </h2>
  );
};

export const Description: React.FC<any> = (props) => {
  return (
    <div id={props.id} className={description}>
      {props.children}
    </div>
  );
};

export const HistoryCarouselFull: React.FC<IHistoryProps> = (props) => {
  const history = props.relationships
    ? props.relationships.field_history || []
    : [];
  const [index, setIndex] = React.useState(0);
  const handleSelect = (selectedIndex: any) => {
    setIndex(selectedIndex);
  };
  const setPrev = () => {
    if (index !== 0) {
      setIndex(index - 1);
    }
  };
  const setNext = () => {
    const count = history.length;
    if (index !== count - 1) {
      setIndex(index + 1);
    }
  };
  if (!history) {
    return null;
  }
  return (
    <div className={historyCarouselFull} id="history-carousel">
      <Carousel
        indicators={false}
        slide={true}
        interval={null}
        controls={false}
        className={timeContainer}
        activeIndex={index}
        onSelect={handleSelect}
        fade={true}
      >
        {history.map((item: any, i: number) => {
          return (
            <Carousel.Item key={i} id={`history-item-${i + 1}`}>
              <span className={line} />
              <div className={circleContainer}>
                <div>
                  <span className={circle} />
                  <div className={timeContent}>
                    <div id="history-item-year">{item.field_title}</div>
                    <p
                      id="history-item-description"
                      className={description}
                      dangerouslySetInnerHTML={{
                        __html: item.field_description,
                      }}
                    />
                  </div>
                </div>
                {history[i + 1] && (
                  <div>
                    <span className={circle} />
                    <div className={timeContent}>
                      <div id={slugify(history[i + 1].field_title)}>
                        {history[i + 1].field_title}
                      </div>
                      <p
                        className={description}
                        id="history-item-description"
                        dangerouslySetInnerHTML={{
                          __html: history[i + 1].field_description,
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
      <div className={controls}>
        <a
          onClick={() => {
            setPrev();
          }}
        >
          <span>
            <FontAwesomeIcon icon={faChevronLeft} />
          </span>
        </a>
        <a
          onClick={() => {
            setNext();
          }}
        >
          <span>
            <FontAwesomeIcon icon={faChevronRight} />
          </span>
        </a>
      </div>
    </div>
  );
};

export const HistoryCarouselMobile: React.FC<any> = (props) => {
  const history = props.relationships
    ? props.relationships.field_history || null
    : null;
  if (!history) {
    return null;
  }
  return (
    <div className={historyCarouselMobile}>
      {history.map((item: any, i: number) => {
        return (
          <div
            key={i}
            style={{ position: "relative" }}
            id={`history-item-${i + 1}`}
          >
            <span className={line} />
            <div className={circleContainer}>
              <div>
                <span className={circle} />
                <div className={timeContent}>
                  <div id="history-item-year">{item.field_title}</div>
                  <p
                    id="history-item-description"
                    className={description}
                    dangerouslySetInnerHTML={{ __html: item.field_description }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
